<template>
  <new-header></new-header>
</template>
<script>
import Vue from 'vue'
import Swiper from 'swiper'

var NewHeader = function (resolve, reject) {
  Vue.commonService.fetchNewHeader()
    .then((response) => {
      resolve({
        template: response.data,
        mounted: function () {
          var vm = this
          // Mobile Menu
          $('[data-id="menutoggle"]').click(function () {
            $('body').addClass('menuOpen')
          })

          $('.mobileOverlay').click(function () {
            $('body').removeClass('menuOpen')
          })

          vm.$watch('$route', function (to) {
            if (to.path === '/' || to.path === '/main') {
              $('#headerWithIcon').show()
              $('#headerWithoutIcon').hide()
              $('#mobileHeaderText').text('')
            } else {
              $('#headerWithIcon').hide()
              $('#headerWithoutIcon').show()

              if (to.path.indexOf('/list') !== -1) {
                $('#mobileHeaderText').text('PayEasy訂房')
              } else if (to.path.indexOf('/detail') !== -1) {
                $('#mobileHeaderText').text('PayEasy訂房')
              } else if (to.path.indexOf('/guest') !== -1) {
                $('#mobileHeaderText').text('訂房明細')
              } else if (to.path.indexOf('/payment') !== -1) {
                $('#mobileHeaderText').text('付款資訊')
              }
            }
          }, {
            deep: true,
            immediate: true
          })
        }
      })
    })
    .catch(() => {
      window.alert('旅遊系統正在維護中，請稍後再試')
      window.location.href = 'http://www.payeasy.com.tw'
    })
}

export default {
  components: {
    'new-header': NewHeader
  },
  data () {
    return {
      swiper: null
    }
  },
  updated () {
    setTimeout(() => {
      this.swiper = new Swiper('.swiper', {
        direction: 'horizontal',
        slidesPerView: 'auto',
        freeMode: true,
        on: {
          slideChange (swip) {
            const barLength = this.snapGrid.length
            if (this.snapIndex) {
              $('.slidePosition').animate(
                {
                  marginLeft: `${(15 * (Number(this.snapIndex) + 1)) / barLength}px`
                },
                10
              )
            } else {
              $('.slidePosition').animate(
                {
                  marginLeft: '0'
                },
                10
              )
            }
          }
        }
      })
    }, 1000)
  }
}
</script>



// WEBPACK FOOTER //
// src/layouts/Header.vue